/**
 * @module app.pm
 * @preferred
 */

import { autoinject, PLATFORM } from 'aurelia-framework';
import { AppLogger } from 'app/shared/lib/logging/app-logger';
import { AppModule } from 'app/shared/config/modules';
import { IAppRouteConfig } from 'app/shared/config/router-types';
import { NavigationInstruction } from 'aurelia-router';

@autoinject()
export class PopulationManagementModule extends AppModule {

    public readonly code = 'pm';

    constructor(private readonly logger: AppLogger) {
        super();

        logger.source = this;
    }

    public getTranslationNamespaces(): ReadonlyArray<string> {
        return ['pm'];
    }

    public getRoutes(): ReadonlyArray<IAppRouteConfig> {
        return [
            { route: 'pm/admin/user-defined-field/:userDefinedFieldDefinitionId', name: 'pm.admin.user-defined-field', navigationStrategy: instruction => this.navigateToUserDefinedFieldDefinition(instruction), settings: { topic: 'pm.admin.user-defined-field', bypassAuthentication: true } },
            { route: 'pm/admin/user-defined-fields', name: 'pm.admin.user-defined-fields', moduleId: PLATFORM.moduleName('app/pm/pages/admin/manage-user-defined-fields-page'), title: 'pm.admin.user-defined-fields', settings: { topic: 'pm.admin.user-defined-fields' } }
        ];
    }

    private async navigateToUserDefinedFieldDefinition(instruction: NavigationInstruction): Promise<void> {
        const { userDefinedFieldDefinitionId } = instruction.params;
        if(typeof userDefinedFieldDefinitionId === 'string') {
            try {
                instruction.config.moduleId = PLATFORM.moduleName(`app/pm/pages/admin/user-defined-field-page`);
                return;
            }
            catch(error) {
                this.logger.error(`Unable to navigate to User Defined Field Definition: ${userDefinedFieldDefinitionId}`);
            }
        }
        // redirect to not found page
        instruction.config.moduleId = PLATFORM.moduleName('app/shared/components/not-found');
    }
}
